import script from "./RequestDisclaimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestDisclaimer.vue?vue&type=script&setup=true&lang=ts"

import "./RequestDisclaimer.vue?vue&type=style&index=0&id=cc8401ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc8401ec"]])

export default __exports__